import React from "react";

const GOLD = "#D4AF37";

// Crisp, fully transparent inline-SVG mandala (no background artefacts)
export function MandalaSVG({ className = "", style }) {
  const petal = (len, w) =>
    `M100 100 C ${100 - w} ${100 - len * 0.45}, ${100 - w} ${100 - len * 0.78}, 100 ${100 - len} C ${100 + w} ${100 - len * 0.78}, ${100 + w} ${100 - len * 0.45}, 100 100 Z`;

  const rings = [
    { count: 24, len: 64, w: 5 },
    { count: 16, len: 48, w: 8 },
    { count: 12, len: 32, w: 6 },
  ];

  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      style={style}
      fill="none"
      stroke={GOLD}
      strokeWidth="0.6"
      aria-hidden="true"
    >
      {[68, 54, 40, 26, 14, 7].map((r) => (
        <circle key={r} cx="100" cy="100" r={r} />
      ))}
      {rings.map((ring, ri) =>
        Array.from({ length: ring.count }).map((_, i) => (
          <path
            key={`${ri}-${i}`}
            d={petal(ring.len, ring.w)}
            transform={`rotate(${(360 / ring.count) * i} 100 100)`}
          />
        ))
      )}
      {Array.from({ length: 36 }).map((_, i) => {
        const a = ((Math.PI * 2) / 36) * i;
        const r = 74;
        return (
          <circle
            key={`d${i}`}
            cx={100 + Math.cos(a) * r}
            cy={100 + Math.sin(a) * r}
            r="0.8"
            fill={GOLD}
            stroke="none"
          />
        );
      })}
    </svg>
  );
}

// Subtle rotating mandala used as a background imprint
export function MandalaImprint({ className = "", size = 520, opacity = 0.06 }) {
  return (
    <MandalaSVG
      className={`pointer-events-none select-none animate-spin-slow ${className}`}
      style={{ width: size, height: size, opacity }}
    />
  );
}

// Small lotus flourish for dividers
function Flourish({ size = 46 }) {
  const count = 8;
  const petal = `M23 23 C 19 14, 19 8, 23 4 C 27 8, 27 14, 23 23 Z`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none"
      stroke={GOLD}
      strokeWidth="0.7"
      aria-hidden="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <path key={i} d={petal} transform={`rotate(${(360 / count) * i} 23 23)`} />
      ))}
      <circle cx="23" cy="23" r="4" />
      <circle cx="23" cy="23" r="1.6" fill={GOLD} stroke="none" />
    </svg>
  );
}

// Elegant transparent divider: hairlines + central lotus flourish
export function PaisleyDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      <span className="h-px w-16 bg-gradient-to-r from-transparent to-gold/50 sm:w-28" />
      <Flourish />
      <span className="h-px w-16 bg-gradient-to-l from-transparent to-gold/50 sm:w-28" />
    </div>
  );
}

// Thin gold jaali (lattice) SVG strip
export function JaaliStrip({ className = "" }) {
  return (
    <svg
      className={className}
      width="100%"
      height="24"
      viewBox="0 0 240 24"
      preserveAspectRatio="none"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <pattern id="jaali" width="24" height="24" patternUnits="userSpaceOnUse">
          <path
            d="M12 0 L24 12 L12 24 L0 12 Z"
            stroke="rgba(212,175,55,0.4)"
            strokeWidth="0.6"
            fill="none"
          />
          <circle cx="12" cy="12" r="3" stroke="rgba(212,175,55,0.4)" strokeWidth="0.6" fill="none" />
        </pattern>
      </defs>
      <rect width="240" height="24" fill="url(#jaali)" />
    </svg>
  );
}
